<template>
  <Form :model="formInline" :rules="rules" ref="ruleForm" label-position="right" label-width="100px">
    <FormItem label="地区" prop="city" v-if="!formInline.classesId">
      <Cascader ref="cascaderRef" :options="regionData" v-model="formInline.city" placeholder="请选择地区" separator=" "
        :props="{ emitPath: false }" style="width: 320px" @change="onCascader"></Cascader>
    </FormItem>
    <FormItem label="学校" prop="school">
      <Select v-model="formInline.school" placeholder="请选择学校" style="width: 320px" filterable @change="changeSchool"
        v-if="!formInline.classesId">
        <Option v-for="item in schoolList" :key="item.schoolId" :label="item.schoolName" :value="item.schoolName">
        </Option>
      </Select>
      <Input v-model="formInline.school" placeholder="请选择学校" style="width: 320px" disabled v-else></Input>
    </FormItem>
    <FormItem label="年级班级" prop="gradeName" style="position: relative;">
      <template v-if="isCustom">
        <Select v-model="formInline.grade" placeholder="请选择年级" style="width: 150px"
          @change="formInline.gradeName = $event">
          <Option v-for="item in classOptions" :key="item.value" :label="item.label" :value="item.value"></Option>
        </Select>
        <Input type="number" :min="16" v-model="formInline.name" placeholder="请输入班级" :controls="false"
          style="width: 140px;margin-left: 10px;" @change="changeClass"></Input>
        班
      </template>
      <Cascader ref="gradeRef" :options="classOptions" v-model="formInline.gradeName" placeholder="请选择年级班级"
        separator=" " style="width: 320px" v-else></Cascader>
      <el-button class="changeBtn" size="small" @click="onCustom">自定义班级</el-button>
    </FormItem>
    <FormItem label="老师姓名" prop="teacherName" v-if="!formInline.classesId">
      <Input v-model="formInline.teacherName" placeholder="请输入您的真实姓名" style="width: 320px" :maxlength="10"></Input>
    </FormItem>
    <FormItem label="入班验证" prop="joinCheckFlag" v-if="formInline.classesId">
      <ElSwitch v-model="formInline.joinCheckFlag" :active-value="1" :inactive-value="0" active-color="#00BC0A"
        inactive-color="#eee">
      </ElSwitch>
      <div class="formTxt">开启后，任何人申请加入班级，均需通过班级管理员审批方可加入班级。关闭后，任何人均可随意加入班级，无需班级管理员审批。</div>
    </FormItem>
    <FormItem label="班级认证" prop="authImg">
      <div class="flex" style="align-items: flex-end">
        <el-upload class="formImg flex-center" action="/api/file/upload.json?source=13" :show-file-list="false"
          :on-success="changeFile"
          v-if="(!formInline.classesId || (formInline.classesId && formInline.authStatus === 'AUTH_NO')) && formInline.authImg.length < 3">
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div class="formImg flex-center iconfont" v-show="formInline.authImg" v-for="(img, idx) in formInline.authImg">
          <ElImage style="width: 100px; height: 100px" :src="img" :preview-src-list="[img]">
          </ElImage>
          <p class="iconfont flex-center shanchu del" @click="formInline.authImg.splice(idx, 1)"
            v-if="!formInline.classesId || (formInline.classesId && formInline.authStatus === 'AUTH_NO')"></p>
        </div>
      </div>
      <p class="statusTip" :class="formInline.authStatus" v-if="formInline.classesId">{{ formInline.authTxt }}</p>

      <div class="formTxt" v-if="!formInline.classesId || formInline.authStatus === 'AUTH_NO'">
        <p>限制：</p>
        png / jpg 格式文件，大小不超过 2M 上传教师证件或在校教学图片
        通过认证的班级将获得认证标识
      </div>
    </FormItem>
    <el-button type="success" class="formBtn" :disabld="false" round @click="submitForm">提交</el-button>
  </Form>
</template>

<script>
import {
  Dialog,
  Form,
  FormItem,
  Select,
  Option,
  Input,
  Cascader,
  Image,
  Button,
  Upload,
  Switch,
  InputNumber
} from "element-ui";
import { regionData } from "element-china-area-data";
import util from 'libs/util'

const grades = [
  "一年级",
  "二年级",
  "三年级",
  "四年级",
  "五年级",
  "六年级",
  "初一",
  "初二",
  "初三",
  "高一",
  "高二",
  "高三",
];

const classList = [
  "1班",
  "2班",
  "3班",
  "4班",
  "5班",
  "6班",
  "7班",
  "8班",
  "9班",
  "10班",
  "11班",
  "12班",
  "13班",
  "14班",
  "15班",
];

export default {
  components: {
    Dialog,
    Form,
    FormItem,
    Select,
    Option,
    Input,
    Cascader,
    InputNumber,
    ElImage: Image,
    ElButton: Button,
    ElUpload: Upload,
    ElSwitch: Switch,
  },
  data() {
    return {
      regionData,
      schoolList: [],
      isCustom: false,
      formInline: {
        schoolId: "",
        school: "",
        city: "",
        grade: null,
        gradeName: null,
        name: null,
        teacherName: null,
        joinCheckFlag: 1,
        authImg: [],//"https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg"
      },
      rules: {
        city: [{ required: true, message: "请选择地区", trigger: "change" }],
        school: [
          { required: true, message: "请选择学校", trigger: "change" },
        ],
        gradeName: [
          { required: true, message: "请选择年级班级", trigger: "change" },
        ],
        teacherName: [
          { required: true, message: "请输入您的真实姓名", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    classOptions() {
      return grades.map((grade, i) => {
        const child = {
          value: i + 1,
          label: grade,
          children: [],
        };
        child.children = classList.map((cls, idx) => {
          return {
            value: idx,
            label: cls,
          };
        });
        return child;
      });
    },
  },
  mounted() {
    // this.loadClassDetail();
  },
  methods: {
    onCustom() {
      this.isCustom = !this.isCustom;
      console.log(this.formInline)
      this.formInline.grade = null;
      this.formInline.gradeName = null;
      this.formInline.name = '';
    },
    changeSchool(e) {
      const item = this.schoolList.filter(item => item.school === e)
      this.formInline.schoolId = item[0].schoolId;
      console.log(this.formInline)
    },
    toLogin() {
      if (util.getStorage('LLSS_TOKEN')) {
        return true;
      } else {
        this.$toast('请先登录')
        this.$router.push('/user/login')
        return false;
      }
    },
    initForm() {
      this.formInline = this.$options.data().formInline;
    },
    submitForm() {
      this.toLogin();
      if (this.isCustom && !this.formInline.name) return this.$toast('请输入大于 15 的班级数字')
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          try {
            const [grade, name] = this.$refs.gradeRef ? this.$refs.gradeRef.getCheckedNodes()[0].pathLabels : [];
            const { schoolObj, authImg, gradeName } = this.formInline;
            const gradeInfo = this.isCustom ? {
              name: this.formInline.name + '班'
            } : {
              grade: gradeName[0],
              name,
            }
            await this.$post('/classes/createClasses.json', {
              ...this.formInline,
              // school: schoolObj.schoolName,
              // schoolId: schoolObj.schoolId,
              authImg: authImg?.join(','),
              ...gradeInfo
            })
            this.$toast(`班级信息${this.formInline.classesId ? '修改' : '保存'}成功`);
            this.$emit('onSuccess')
          } catch (error) {
            this.$toast(`填写信息有误，请核验后再试`);
            console.log(error)
          }
        } else {

          return false;
        }
      });
    },
    changeClass(e) {
      if (this.isCustom && e && e < 16) {
        this.$toast('请输入大于 15 的数字')
        this.formInline.name = null;
      }
    },
    changeFile(res, file) {
      this.formInline.authImg.push(file.response.data);
    },
    onCascader(e) {
      this.schoolList = []
      this.formInline = {
        ...this.formInline,
        school: null,
        schoolId: "",
        grade: null,
        teacherName: null,
        gradeName: null,
        name: null,
      };
      const [province, city] = this.$refs.cascaderRef.getCheckedNodes()[0].pathLabels;
      this.checkedOrga(province, city)
    },
    checkedOrga(province, city) {
      this.toLogin();
      this.$post('/classes/searchschool.json', {
        pageNum: 1,
        pageSize: -1,
        province,
        city: city === '市辖区' ? province.slice(0, province.length - 1) + '市' : city
      }).then((res) => {
        this.schoolList = res.data.list || [];
      }).catch((e) => {
        console.log(e)
      })
    },
    async loadClassDetail(classesId) {
      this.isCustom = false;
      this.$refs.ruleForm.resetFields();
      if (!classesId) return this.initForm();
      try {
        const res = await this.$post('/classes/classesInfo.json', {
          classesId
        });
        const info = res.data || {};
        // if (info.cityOutput) {
        //   const [province, city] = info.cityOutput.split('-');
        //   this.checkedOrga(province, city);
        // }
        info.authImg = info.authImg ? info.authImg.split(',') : [];
        // info.schoolObj = {
        //   schoolName: info.school,
        // }
        info.gradeName = [info.grade, classList.findIndex(item => item == info.name)]
        info.authTxt = (info.authTime || '') + ' ' + {
          AUTH_WAITING: '班级验证进行中，请耐心等待审核',
          AUTH_YES: '验证通过',
          AUTH_NO: '验证失败 请重新认证',
        }[info.authStatus]
        const className = info.name.replace('班', '');
        this.isCustom = Number(className) > 15;
        if (this.isCustom) info.name = className;
        this.formInline = info;
      } catch (error) {
        console.log(error)
      }
    },
  },
  // watch: {
  //   classId(id) {
  //     if (id) this.loadClassDetail();
  //   }
  // }
};
</script>

<style lang="less" scoped>
/deep/.el-form-item__label {
  font-weight: bold;
}

.statusTip {
  color: #00BC0A;
  font-size: 12px;

  &.AUTH_NO {
    color: #FF5C5C;
  }

  &.AUTH_WAITING {
    color: #FFAC00;
  }
}

.changeBtn {
  position: absolute;
  top: 4px;
  left: 334px;
}

.formImg {
  width: 90px;
  height: 90px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #eeeeee;
  font-size: 36px;
  color: #dddddd;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  margin-right: 10px;

  .imgFile {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  .del {
    width: 100%;
    height: 20px;
    position: absolute;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 0px 0px 4px 4px;
  }
}

.formTxt {
  // width: 179px;
  font-family: AlibabaPuHuiTiR;
  font-size: 12px;
  color: #999;
  margin-top: 10px;
  line-height: 1.7;
}

.formBtn {
  margin-top: 30px;
  margin-bottom: 60px;
  width: 320px;
  margin-left: 50px;
}
</style>
